import { gql } from '@apollo/client';

export const FILTERED_EDUCATORS = gql`
  query filteredSchoolEducators($input: SearchData!) {
    educators: filteredSchoolEducators(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          year
          term
          emisNumber
          educatorName
          attendanceRate
          daysAbsent
          circuit {
            id
            name
          }
          district {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
    }
  }
`;
